import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function MCStatDot({ variant = 'cyan', pulse = false, className = '' }) {
    return (_jsx("span", { className: `mc-dot mc-dot-${variant} ${pulse ? 'mc-pulse' : ''} ${className}`, "aria-hidden": "true" }));
}
